import React, { useEffect } from 'react';
import { Outlet, useLocation, useOutletContext } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './components/ui-components/TopBar';
import { HeaderSlotProvider } from './components/ui-components/HeaderSlot';
import { recordAppPath } from './lib/lastAppPath';
import './index.css';

export default function Main() {
    const location = useLocation();

    useEffect(() => {
        document.title = 'InstantViewAI';
    }, []);

    // Remember the last operational location so the Settings shell's "Exit to app"
    // returns the user here. Main only mounts on non-settings routes, so every
    // recorded path is an app path by construction — except pure redirects that
    // bounce into the Settings shell (e.g. the legacy /gcp-configuration →
    // /source-connections redirect), which we skip so Exit-to-app can't loop back in.
    useEffect(() => {
        if (location.pathname === "/gcp-configuration") return;
        recordAppPath(location.pathname + location.search);
    }, [location]);

    return (
        <HeaderSlotProvider>
            <div className="app h-full min-h-full flex flex-row w-full min-w-full bg-bg">
                <Sidebar />
                {/* The content column owns the vertical scroll (not the document), so the
                    TopBar scrolls away with the page while the Sidebar stays fixed. */}
                <div className="flex flex-1 w-full flex-col min-w-0 overflow-y-auto">
                    <TopBar />
                    <Outlet context={useOutletContext()} />
                </div>
            </div>
        </HeaderSlotProvider>
    );
}
